/**
 * Interactive Map source detection.
 *
 * The Interactive Map page prefers an Engrain Sightmap when a per-property
 * sitemap ID (or embed URL) is present, and otherwise falls back to the
 * ApartmentSync (Repli360 / RRAC) interactive leasing setup.
 */

function hasTrimmedValue(value: unknown): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}

const ENGRAIN_SITEMAP_FIELDS = [
  'custom_engrain_sightmap_id',
  'custom_engrain_sitemap_id',
  'custom_engrain_sightmap_url',
  'custom_engrain_sitemap_url',
] as const;

export function hasEngrainSitemap(property: Record<string, unknown> | null | undefined): boolean {
  if (!property) return false;
  return ENGRAIN_SITEMAP_FIELDS.some((field) => hasTrimmedValue(property[field]));
}

export function hasApartmentSyncMap(property: Record<string, unknown> | null | undefined): boolean {
  if (!property) return false;
  return (
    hasTrimmedValue(property.custom_apartmentsync_javascript_id) &&
    hasTrimmedValue(property.custom_apartmentsync_config_id)
  );
}
